import { Locales } from '@calendly/i18n'
import moment from 'moment-timezone'

import { MOMENT_TO_APP_LOCALE } from 'services/locale_mapping'

export {
  momentLocaleFor,
  momentFormatLocaleFor,
} from 'services/locale_mapping'

const devLocaleAllowlist = process.env.WEBPACK_DEV_LOCALES
  ? process.env.WEBPACK_DEV_LOCALES.split(',').map((locale) => locale.trim()).filter(Boolean)
  : null

const includeLocale = (code) => !devLocaleAllowlist || devLocaleAllowlist.includes(code)

const mainLocaleLoaders = {
  ...(includeLocale('de') ? { de: () => import(/* webpackChunkName: "locales/de" */'locales/de.locale') } : {}),
  ...(includeLocale('en') ? { en: () => import(/* webpackChunkName: "locales/en" */'locales/en.locale') } : {}),
  ...(includeLocale('es') ? { es: () => import(/* webpackChunkName: "locales/es" */'locales/es.locale') } : {}),
  ...(includeLocale('fr') ? { fr: () => import(/* webpackChunkName: "locales/fr" */'locales/fr.locale') } : {}),
  ...(includeLocale('it') ? { it: () => import(/* webpackChunkName: "locales/it" */'locales/it.locale') } : {}),
  ...(includeLocale('nl') ? { nl: () => import(/* webpackChunkName: "locales/nl" */'locales/nl.locale') } : {}),
  ...(includeLocale('uk') ? { uk: () => import(/* webpackChunkName: "locales/nl" */'locales/uk.locale') } : {}),
  ...(includeLocale('ps') ? { ps: () => import(/* webpackChunkName: "locales/ps" */'locales/ps.locale') } : {}),
  ...(includeLocale('pt') ? { pt: () => import(/* webpackChunkName: "locales/pt" */'locales/pt.locale') } : {}),
}

const mainLocales = new Locales(mainLocaleLoaders)

const momentLocaleLoaders = {
  ...(includeLocale('de') ? { de: () => import(/* webpackChunkName: "moment/locale/de" */'moment/locale/de') } : {}),
  ...(includeLocale('en') ? { en: () => Promise.resolve({}) } : {}),
  ...(includeLocale('es') ? { es: () => import(/* webpackChunkName: "moment/locale/es" */'moment/locale/es') } : {}),
  ...(includeLocale('fr') ? { fr: () => import(/* webpackChunkName: "moment/locale/fr" */'moment/locale/fr') } : {}),
  ...(includeLocale('it') ? { it: () => import(/* webpackChunkName: "moment/locale/it" */'moment/locale/it') } : {}),
  ...(includeLocale('nl') ? { nl: () => import(/* webpackChunkName: "moment/locale/nl" */'moment/locale/nl') } : {}),
  ...(includeLocale('uk') ? { uk: () => import(/* webpackChunkName: "moment/locale/nl" */'moment/locale/uk') } : {}),
  ...(includeLocale('ps') ? { ps: () => import(/* webpackChunkName: "moment/locale/ps" */'moment/locale/x-pseudo') } : {}),
  ...(includeLocale('pt') ? { pt: () => import(/* webpackChunkName: "moment/locale/pt" */'moment/locale/pt') } : {}),
}

const loadMomentLocales = async (locales) => {
  const originalLocale = moment.locale()

  await Promise.all(
    locales
      .filter((locale) => momentLocaleLoaders[locale])
      .map((locale) => momentLocaleLoaders[locale]()),
  )

  moment.locale(originalLocale)
}

const normalizeAppLocales = (locales) => (
  locales
    .flat()
    .filter(Boolean)
    .map((locale) => MOMENT_TO_APP_LOCALE[locale] || locale)
    .filter((locale) => typeof mainLocaleLoaders[locale] === 'function')
)

export const loadLocale = async (...locales) => {
  const normalizedLocales = normalizeAppLocales(locales)

  if (normalizedLocales.length === 0) return

  await Promise.all([
    mainLocales.load(normalizedLocales),
    loadMomentLocales(normalizedLocales),
  ])
}
